<template>
  <div class="hints-container">
    <div class="icons">
      <f-awesome v-if="type == 'youtube'" @click="showPopup" icon="play-circle"></f-awesome>
      <f-awesome v-if="type == 'text'" @click="showText" icon="question-circle"></f-awesome>
    </div>

    <popup
        :closeButton="text.closeButton"
        :show="text.show"
        @closePopup="closeText"
    >
      <div slot="header">{{title}}</div>
      <div slot="body">
        <slot name="text"></slot>
      </div>
    </popup>


    <popup
        :closeButton="popup.closeButton"
        :show="popup.show"
        @closePopup="closePopup"
    >
      <div slot="header">{{title}}</div>
      <div slot="body">
        <div v-if="popup.show === true && type == 'youtube'" class="youtube">
          <iframe
              width="100%"
              height="auto"
              :src="url"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
          ></iframe>
        </div>
      </div>
    </popup>

  </div>
</template>

<script>

import Popup from "@/components/Popup";
export default {
  name: "Hints",
  components: {Popup},
  data(){
    return {
      popup: {
        show: false,
        closeButton: "Закрыть",
      },
      text: {
        show: false,
        closeButton: "Закрыть",
      }
    }
  },
  props: {
    type: String,
    title: String,
    url: String
  },
  watch: {

  },
  computed: {

  },
  methods: {
    showPopup(){
      this.popup.show = true;
    },
    closePopup(){
      this.popup.show = false;
    },
    showText(){
      this.text.show = true;
    },
    closeText(){
      this.text.show = false;
    }
  }
};
</script>

<style scoped lang="less">
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(204, 169, 44, 0.9);
  }
  100% {
    box-shadow: 0px 0px 24px 0px rgba(65, 162, 252, 1);
  }
}
.hints-container{
  display: inline;
  cursor: pointer;
  color: #F97979;
  border-radius: 10px;
  position: relative;

  .icons{
    display: inline-block;
    width: 15px;
    height: 15px;
  }

  & svg{
    font-size: 16px;
    animation: pulse 1s infinite;
    border-radius: 15px;
  }
}



</style>
